<template>
  <div>
    <b-modal id="productConfiguration" title="Service Hands-on-fees" size="lg">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Product Commission
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <div class="lock-header">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th rowspan="2" style="vertical-align: middle;">Product</th>
                    <th colspan="3" style="text-align: center;">Senior</th>
                    <th colspan="3" style="text-align: center;">Junior</th>
                    <th colspan="3" style="text-align: center;">Assistant</th>
                  </tr>
                  <tr>
                    <th style="text-align: center;">Sales</th>
                    <th style="text-align: center;">Credit Redeem</th>
                    <th style="text-align: center;">Voucher Redeem</th>
                    <th style="text-align: center;">Sales</th>
                    <th style="text-align: center;">Credit Redeem</th>
                    <th style="text-align: center;">Voucher Redeem</th>
                    <th style="text-align: center;">Sales</th>
                    <th style="text-align: center;">Credit Redeem</th>
                    <th style="text-align: center;">Voucher Redeem</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(service, index) of selectedServices" :key="'service_' + index">
                    <td>
                      <label class="form-label">{{ service['name'] }}</label>
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="salesSenior[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="creditSenior[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="voucherSenior[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="salesJunior[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="creditJunior[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="voucherJunior[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="salesAssistant[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="creditAssistant[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                    <td style="min-width: 125px">
                        <input
                          class="form-control"
                          v-model="voucherAssistant[service['id']]"
                          type="text"
                          :searchable="false"
                          :show-labels="false" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>

<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "productConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      services: [],
      selectedServices: [],

      selectedOutlet: {},

      salesSenior: {},
      creditSenior: {},
      voucherSenior: {},
      salesJunior: {},
      creditJunior: {},
      voucherJunior: {},
      salesAssistant: {},
      creditAssistant: {},
      voucherAssistant: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('productConfiguration')
      this.loadSection()
    },

    onOutletChange() {
      this.effort = {}
      this.loadCommission()
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedServices.splice(0, this.selectedServices.length)

      for (let service of this.services) {
        if (service['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedServices.push({ id: service['skuID'], name: service['name'] })
        }
      }
    },

    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=2',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadService()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadService() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=2&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.services = response.data.skus
          this.filterBySection(this.selectedSection)
          this.onOutletChange()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      for(let service of this.services) {
        this.salesSenior[service['skuID']] = ''
        this.creditSenior[service['skuID']] = ''
        this.voucherSenior[service['skuID']] = ''
        this.salesJunior[service['skuID']] = ''
        this.creditJunior[service['skuID']] = ''
        this.voucherJunior[service['skuID']] = ''
        this.salesAssistant[service['skuID']] = ''
        this.creditAssistant[service['skuID']] = ''
        this.voucherAssistant[service['skuID']] = ''
      }
      
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_Unifit_fixedCommission_product_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_Unifit_fixedCommission_product_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          for (let key in response.data) {
            this.salesSenior[key] = (response.data[key]['sales'] || {})['Senior'] || ''
            this.creditSenior[key] = (response.data[key]['credit'] || {})['Senior'] || ''
            this.voucherSenior[key] = (response.data[key]['voucher'] || {})['Senior'] || ''
            this.salesJunior[key] = (response.data[key]['sales'] || {})['Junior'] || ''
            this.creditJunior[key] = (response.data[key]['credit'] || {})['Junior'] || ''
            this.voucherJunior[key] = (response.data[key]['voucher'] || {})['Junior'] || ''
            this.salesAssistant[key] = (response.data[key]['sales'] || {})['Assistant'] || ''
            this.creditAssistant[key] = (response.data[key]['credit'] || {})['Assistant'] || ''
            this.voucherAssistant[key] = (response.data[key]['voucher'] || {})['Assistant'] || ''
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for(let service of this.services) {
        request[service['skuID']] = request[service['skuID']] || {}
        request[service['skuID']]['sales'] = request[service['skuID']]['sales'] || {}
        request[service['skuID']]['sales']['Senior'] = this.salesSenior[service['skuID']]
        request[service['skuID']]['sales']['Junior'] = this.salesJunior[service['skuID']]
        request[service['skuID']]['sales']['Assistant'] = this.salesAssistant[service['skuID']]
        request[service['skuID']]['credit'] = request[service['skuID']]['credit'] || {}
        request[service['skuID']]['credit']['Senior'] = this.creditSenior[service['skuID']]
        request[service['skuID']]['credit']['Junior'] = this.creditJunior[service['skuID']]
        request[service['skuID']]['credit']['Assistant'] = this.creditAssistant[service['skuID']]
        request[service['skuID']]['voucher'] = request[service['skuID']]['voucher'] || {}
        request[service['skuID']]['voucher']['Senior'] = this.voucherSenior[service['skuID']]
        request[service['skuID']]['voucher']['Junior'] = this.voucherJunior[service['skuID']]
        request[service['skuID']]['voucher']['Assistant'] = this.voucherAssistant[service['skuID']]
      }


      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_Unifit_fixedCommission_product_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_Unifit_fixedCommission_product_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('productConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>

<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}

.lock-header {
	overflow: -moz-scrollbars-vertical; 
  overflow-y: scroll;
  max-height: 75vh;
}

.lock-header thead {
  position: sticky;
  top: 0;
	background-color: #fff;
	z-index: 11;
}

.lock-header td:nth-child(1) {
  position: sticky;
  left: 0;
	background-color: #fff;
  z-index: 10;
}

.lock-header tr:nth-of-type(odd) td:nth-child(1) {
    background-color: #f4f4f4;
}
</style>